import React from "react";
import {useSelector, useDispatch} from "react-redux";
import {useToasts} from "react-toast-notifications";

import {demoMarkPaymentNotCompleted} from "../../../../store/actions/admission";

/**
 * Demo-only action: reverts an admission from "payment done" back to the signature step,
 * so the payment step can be replayed during a demo.
 */
const DemoMarkPaymentNotCompletedLink = ({admission, onHide}) => {
    const dispatch = useDispatch();
    const {addToast} = useToasts();
    const {demo, selectedHospital} = useSelector(state => state.auth);

    if (!demo || !demo.demoHospital || !selectedHospital || (demo.demoHospital.id !== selectedHospital.id)) {
        return null;
    }
    if ((admission.statusPPStr !== 'STATUS_PP_PAYMENT_DONE') || (admission.completed_payments_count === 0)) {
        return null;
    }

    const doMarkPaymentNotCompleted = () => {
        if (onHide) {
            onHide();
        }
        dispatch(demoMarkPaymentNotCompleted(admission, addToast));
    }

    return (
        <a className="dropdown-item pointer" onClick={doMarkPaymentNotCompleted}>[DEMO] Mark payment as not completed</a>
    );
}

export default DemoMarkPaymentNotCompletedLink;
